import axios from "axios";
import { is, curryN, gte } from "ramda";
import https from "https";
import { handleError } from "vue";
import { toast } from "vue3-toastify";

let toast_showed = false;

const isWithin = curryN(3, (min, max, value) => {
  const isNumber = is(Number);
  return isNumber(min) && isNumber(max) && isNumber(value) && gte(value, min) && gte(max, value);
});
const in200s = isWithin(200, 299);

//console.log(token)
const generalDataApi = (url, timeout) => {
  const token = localStorage.getItem("token");
  return axios.create({
    baseURL: url,
    httpsAgent: new https.Agent({
      rejectUnauthorized: false,
    }),
    headers: {
      Accept: "application/json",
      //"Content-Type": "application/json; charset=utf-8",
      Authorization: "Bearer " + token,
    },
    timeout: timeout,
  });
};

function make_post_request(url, timeout, section, param, customHeaders = {}, intento = 0) {
  if (intento > 3)
    return {
      status: false,
      msg: "Error en el sistema luego de reintentar conexión, CODE: MaxRetry",
      code: 3,
    };

  return generalDataApi(url, timeout)
    .post(section, param, customHeaders)
    .then((response) => {
      if (in200s(response.status)) {
        if (response.data !== undefined) {
          return response.data;
        }
        return {
          status: false,
          msg: "Error en el sistema, CODE: 501",
          code: 501,
        };
      }
      console.log(response);
      return {
        status: false,
        msg: "Hubo un error en la conexión de internet, reintente nuevamente, CODE: " + response.status,
        code: response.status,
      };
    })
    .catch((e) => {
      //console.log(e.response.code)
      //console.log(e)
      verifyExpiring(e);
      throw e;
    });
}

function make_get_request(url, timeout, section, param = {}, intento = 0) {
  if (intento > 3)
    return {
      status: false,
      msg: "Error en el sistema luego de reintentar conexión, CODE: MaxRetry",
      code: 3,
    };

  return generalDataApi(url, timeout)
    .get(section, param)
    .then((response) => {
      if (in200s(response.status)) {
        if (response.data !== undefined) {
          return response.data;
        }
        return {
          status: false,
          msg: "Error en el sistema, CODE: 501",
          code: 501,
        };
      }
      return {
        status: false,
        msg: "Hubo un error en la conexión de internet, reintente nuevamente, CODE1: " + response.status,
        code: response.status,
      };
    })
    .catch((e) => {
      verifyExpiring(e);
      throw e;
    });
}

function make_delete_request(url, timeout, section, param, intento = 0) {
  if (intento > 3)
    return {
      status: false,
      msg: "Error en el sistema luego de reintentar conexión, CODE: MaxRetry",
      code: 3,
    };

  return generalDataApi(url, timeout)
    .delete(section, { data: param })
    .then((response) => {
      if (in200s(response.status)) {
        if (response.data !== undefined) {
          return response.data;
        }
        return {
          status: false,
          msg: "Error en el sistema, CODE: 501",
          code: 501,
        };
      }
      return {
        status: false,
        msg: "Hubo un error en la conexión de internet, reintente nuevamente, CODE1: " + response.status,
        code: response.status,
      };
    })
    .catch((e) => {
      console.log("requestService.delete");
      console.log(e);
      verifyExpiring(e);
      throw e;
    });
}

function make_put_request(url, timeout, section, param, intento = 0) {
  if (intento > 3)
    return {
      status: false,
      msg: "Error en el sistema luego de reintentar conexión, CODE: MaxRetry",
      code: 3,
    };

  return generalDataApi(url, timeout)
    .put(section, param)
    .then((response) => {
      if (in200s(response.status)) {
        if (response.data !== undefined) {
          return response.data;
        }
        return {
          status: false,
          msg: "Error en el sistema, CODE: 501",
          code: 501,
        };
      }
      return {
        status: false,
        msg: "Hubo un error en la conexión de internet, reintente nuevamente, CODE1: " + response.status,
        code: response.status,
      };
    })
    .catch((e) => {
      verifyExpiring(e);
      throw e;
    });
}

function verifyExpiring(e) {
  const code = e.request !== undefined ? e.request.status : e.code;
  if (code != undefined) {
    if (code == 401) {
      const data = JSON.parse(e.request.response);
      if(data.msg === "Token is Expired" || data.msg === "El token no coincide con el ultimo generado."){
        localStorage.removeItem("token");
        localStorage.removeItem("user");        
        //alert("Su sesión ha expirado o se ha iniciado en otro dispositivo. Será redirigido al inicio de sesión.");
        if(!toast_showed){
          toast.error("Su sesión ha expirado. Será redirigido al inicio de sesión.");
          toast_showed = true;
          setTimeout(() => {
            toast_showed = false;
            window.location.reload();            
          }, 2000);
        }
        return;
        
      }
    }
  }  
}

function handle_error(log, e) {
  if (e.response != undefined) {
    const data = e.response.data;

    //Una respuesta ya armada con WSResponse::GetResponse (status/msg/code/result) se devuelve
    //tal cual. Un 500 no controlado por el backend (excepcion sin catch) lo agarra el handler
    //default de Laravel y devuelve {message, exception, file, line, trace} en su lugar: sin
    //este chequeo esa respuesta pasaba cruda y el caller (toast.error(response.msg)) mostraba
    //"undefined", dejando el error invisible para el usuario.
    if (data != undefined && data.status != undefined && data.msg != undefined) {
      return data;
    }

    return {
      status: false,
      msg: (data && data.message) || "Error interno del servidor, CODE:" + e.response.status,
      code: e.response.status,
      exception: e,
    };
  }

  const code = e.request !== undefined ? e.request.status : e.code;
  if (code != undefined) {
    if (code === "ECONNABORTED")
      return {
        status: false,
        msg: "No se puede alcanzar el servidor, verifique su conexión.",
        code: e.code,
        exception: e,
      };

    if (code == 400) {
      return {
        status: false,
        msg: "Bad Request, CODE:" + code,
        code: code,
        exception: e,
      };
    }

    if (code == 401)
      return {
        status: false,
        msg: "Acceso no autorizado, CODE:" + code,
        code: code,
        exception: e,
      };

    if (code == 403)
      return {
        status: false,
        msg: "Forbidden, CODE:" + code,
        code: code,
        exception: e,
      };

    if (code == 404)
      return {
        status: false,
        msg: "Not Found, CODE:" + code,
        code: code,
        exception: e,
      };

    if (code == 405)
      return {
        status: false,
        msg: "Method Not Allowed, CODE:" + code,
        code: code,
        exception: e,
      };

    if (code == 408)
      //Request Timeout
      return {
        status: false,
        msg: "Request Timeout, CODE:" + code,
        code: code,
        exception: e,
      };

    if (code == 410)
      return {
        status: false,
        msg: "Request Gone, CODE:" + code,
        code: code,
        exception: e,
      };

    if (code == 500)
      return {
        status: false,
        msg: "Internal Server Error on request, CODE:" + code,
        code: code,
        exception: e,
      };

    return {
      status: false,
      msg: "Hubo un error en la conexión de internet, reintente nuevamente, CODE:" + code,
      code: code,
      exception: e,
    };
  }

  return {
    status: false,
    msg: "Hubo un error en la conexión de internet, reintente nuevamente.",
    code: -1,
    exception: e,
  };
}

export const requestService = {
  make_post_request,
  make_get_request,
  make_put_request,
  make_delete_request,
  handle_error,
};
